<div class="row-layout">
  <div class="column-layout">
    <div class="personal-section">
      <mat-card>
        <mat-card-subtitle>
          <span>PERSONAL INFO</span>
        </mat-card-subtitle>
        <mat-card-content>
          <div class="info-section">
            <div class="name-info">
              <span class="full-name">{{ profileUser().fullName }}</span>
              <span class="user-name">({{ profileUser().username }})</span>
              <div class="job-info">
                <span>{{ profileUser().organization || "Not Available" }}</span>
              </div>
            </div>

            <!--Job title, organization, company-->
            <!--City, state, zip-->

            <div class="contact-info">
              <span class="section-header">Contact Info</span>
              <div>
                <span>{{ profileUser().email }}</span>
                <!-- Phone number              -->
              </div>
            </div>

            <div class="reason-info">
              <span class="section-header">Reason For Account</span>
              <div>
                <span>{{ profileUser().reason || "Not Available" }}</span>
              </div>
            </div>
          </div>

          <div class="api-key-info">
            <span class="section-header">API Keys</span>

            @if (profileUser().apiKeys.length === 0) {
              <div>
                <p>No API keys available</p>

              </div>
            } @else {
              <div class="api-key-list">
                @for (apiKey of profileUser().apiKeys; track apiKey.id) {
                  <div>
                    <div class="api-key-row">
                      <div class="api-key-meta">
                        <span class="api-key-name">{{ apiKey.key }}</span>
                        <button mat-icon-button (click)="copyApiKey(apiKey.key)">
                          <vulcan-icon size="24px" icon="clipboard-text"/>
                        </button>
                      </div>

                      <div class="api-key-actions">
                        <div>
                          <b>Expires: </b> <span>{{ apiKey.expiresAt.toDate() | date: 'MM/dd/yyyy' }}</span>
                        </div>
                        <button mat-stroked-button (click)="renewApiKey(apiKey)">
                          Renew for one year
                        </button>
                      </div>

                    </div>
                  </div>
                }
              </div>
            }

          </div>

          <div>
            <button mat-stroked-button (click)="openPasswordResetModal()">
              Reset Password
            </button>
            <p class="reset-info">
              <span>{{ profileUser().daysSincePasswordReset }}</span> Days since
              last password reset
            </p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  @if (hasAdminControls()) {
    <div class="column-layout">
      <div class="admin-section">
        <mat-card>
          <mat-card-subtitle>
            <span>ADMIN INFO</span>
          </mat-card-subtitle>
          <mat-card-content>
            <div class="info-section">
              <div class="role-info">
              <span class="section-header roles">
                Roles
                <mat-icon class="clickable" inline (click)="openEditRoleModal()">edit</mat-icon>
              </span>
                <div class="user-roles">
                  @for (role of visibleRoles(); track role) {
                    <span class="role-name">{{ role | roleName }}</span>
                  } @empty {
                    <span class="role-name">No roles assigned.</span>
                  }
                </div>
              </div>

              @if (!profileUser().approved) {
                <div class="account-approval-section">
                  <button mat-flat-button color="primary" (click)="approveUser()">
                    Approve
                  </button>
                  <button mat-flat-button color="warn" [matMenuTriggerFor]="denyReasonsMenu">
                    Deny
                  </button>
                </div>
              } @else {
                <div class="approved-states">
              <span class="section-header">Approved States
                @if (stateRequest() && stateRequest()!.length > 0) {
                  <vulcan-icon matTooltip="User requested additional states" class="info-icon" size="20px"
                               (click)="openApprovedStatesModal()" icon="info"></vulcan-icon>
                }
              </span>
                  <p>{{ approvedStatesList() }}</p>
                  <div class="approved-state-actions">
                    <button mat-stroked-button (click)="openApprovedStatesModal()">
                      Change Approved States
                    </button>
                    @if (!hasNationalAccess()) {
                      <button mat-flat-button color="primary"
                              [disabled]="isGrantingNationalAccess()"
                              (click)="openNationalAccessConfirmation()">
                        Allow National Access
                      </button>
                    }
                  </div>
                </div>
              }

              <!--        enable/disable, impersonate-->
              <div class="user-status-actions">
                @if (profileUser().isEnabled()) {
                  <button mat-stroked-button (click)="disableUser()">
                    Disable User
                  </button>
                } @else {
                  <button mat-stroked-button color="primary" (click)="enableUser()">
                    Enable User
                  </button>
                }
                @if (canImpersonate) {
                  <div matTooltip="Unable to impersonate a disabled user"
                       [matTooltipDisabled]="profileUser().isEnabled()" matTooltipShowDelay="250"
                       matTooltipPosition="above">
                    <button mat-flat-button color="primary" [disabled]="!profileUser().isEnabled()"
                            (click)="impersonateUser()">
                      Impersonate
                    </button>
                  </div>
                }
              </div>

              <!--        Login information -->
              <div class="login-info">
                <span class="section-header">Login Info</span>
                <div>
                <span class="last-login">
                  Last Login Date:
                  @if (profileUser().lastLoginDate) {
                    <b>{{
                        profileUser().lastLoginDate.toDate() | date: "short"
                      }}</b>
                  } @else {
                    <b>User has not logged in</b>
                  }
                </span>
                  <br/>
                  <span class="join-date">Join Date:
                  <b>{{
                      profileUser().joinDate.toDate() | date: "short"
                    }}</b></span>
                </div>
              </div>

              <div class="password-reset">
                <button mat-stroked-button (click)="sendPasswordResetEmail()">
                  Send Password Reset Email
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  }

  <div class="column-layout">
    @if (hasPoc() && profileUser().pointOfContact) {
      <div class="poc-section">
        <mat-card>
          <mat-card-subtitle>
            <span>FEDERAL POINT OF CONTACT INFO</span>
          </mat-card-subtitle>
          <mat-card-content>
            <div class="info-section">
              <div class="name-info">
              <span class="full-name">{{
                  profileUser().pointOfContact.name || "Not Available"
                }}</span>

                <div class="job-info">
                  <span>{{ profileUser().pointOfContact.title }}</span> &#183;
                  <span>{{ profileUser().pointOfContact.department }}</span>
                  &#183;
                  <span>{{ profileUser().pointOfContact.organization }}</span>
                </div>
              </div>

              <!--Job title, organization, company-->
              <!--City, state, zip-->

              <div class="contact-info">
                <span class="section-header">Contact Info</span>
                <div class="poc-contact-info">
                  <a [href]="'mailTo:' + profileUser().pointOfContact.email">
                    {{ profileUser().pointOfContact.email || "N/A" }}
                  </a>
                  <a [href]="'tel:' + profileUser().pointOfContact.telephone">
                    {{
                      profileUser().pointOfContact.telephone || "N/A"
                        | phoneNumber
                    }}
                  </a>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }

    <mat-menu #denyReasonsMenu="matMenu">
      @for (reason of denialReasons; track reason) {
        <button mat-menu-item (click)="denyUser(reason)">
          {{ reason }}
        </button>
      }
    </mat-menu>
  </div>
